import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, ShieldCheck } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Aydınlatma metni güncellendiğinde firma yeniden onay verene kadar kapatılamaz
export const ConsentRequiredDialog = ({ open, onAccepted }) => {
  const [doc, setDoc] = useState(null);
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) axios.get(`${API}/public/aydinlatma-metni`).then(res => setDoc(res.data)).catch(() => setDoc(null));
  }, [open]);

  const accept = async () => {
    setSaving(true);
    try {
      await axios.post(`${API}/my-company/consent`, { version_id: doc.version_id });
      toast.success('Aydınlatma Metni onaylandı');
      setChecked(false);
      onAccepted();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Onaylanamadı');
      if (err.response?.status === 409) axios.get(`${API}/public/aydinlatma-metni`).then(res => setDoc(res.data));
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open}>
      <DialogContent className="max-w-2xl max-h-[92vh] overflow-y-auto [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} data-testid="consent-required-dialog" data-allow-pending>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-blue-600" />Aydınlatma Metni Güncellendi{doc ? ` (v${doc.version})` : ''}</DialogTitle>
          <DialogDescription>İşlem yapmaya devam edebilmek için güncel İSG Permit Aydınlatma Metni'ni okuyup onaylamanız gerekiyor.</DialogDescription>
        </DialogHeader>
        {!doc ? <Loader2 className="h-6 w-6 animate-spin text-slate-400" /> : (
          <div className="max-h-[40vh] overflow-y-auto rounded-lg border bg-slate-50 p-4 whitespace-pre-wrap text-sm text-slate-700" data-testid="consent-required-text">{doc.text}</div>
        )}
        <div className="flex items-center gap-2">
          <Checkbox id="consent-required-check" checked={checked} onCheckedChange={(c) => setChecked(!!c)} data-testid="consent-required-checkbox" />
          <label htmlFor="consent-required-check" className="text-sm text-slate-700 cursor-pointer">Okudum ve anladım</label>
        </div>
        <div>
        <Button onClick={accept} disabled={!checked || !doc || saving} className="w-full bg-slate-900 hover:bg-slate-800" data-testid="consent-required-accept">
          {saving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Onaylıyorum
        </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
